"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
/**
 * This is just the base implementation for any pdf client that needs to
 * be implemented in any of our applications. The important bits are:
 * - The response type is set as an 'arraybuffer',
 * - The headers were configured to automatically send { Accept: application/pdf }.
 * - The response is transformed to a blob before being reported.
 *
 * Note that since this is an AxiosInstance, you can still modify the default
 * configurations to adjust to the app's requirements, mainly the baseUrl and any
 * custom interceptors
 */
var BasePdfClient = axios_1.default.create({
    responseType: 'arraybuffer',
    headers: {
        Accept: 'application/pdf',
    },
    transformResponse: function (data) { return new Blob([data]); },
});
exports.default = BasePdfClient;
//# sourceMappingURL=BasePdfClient.js.map